import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';

@Injectable({ providedIn: 'root' })
export class AuthService {
  constructor(private msalService: MsalService) {}

  get isAdmin(): boolean {
    const account = this.msalService.instance.getActiveAccount()
      ?? this.msalService.instance.getAllAccounts()[0];
    const roles = (account?.idTokenClaims as Record<string, unknown>)?.['roles'] as string[] | undefined;
    return roles?.includes('cordellidentity.admin') ?? false;
  }
}
